export class ServicoSubClienteDTO {
    nomeSubCliente?: string;
    cpfCnpj?: string;
    email?: string;
    telefone?: string;
    cep?: string;
    tipoEndereco?: string;
    logradouro?: string;
    numero?: string;
    complemento?: string;
    bairro?: string;
    cidade?: string;
    estado?: string;
    constructor(
        nomeSubCliente?: string,
        cpfCnpj?: string,
        email?: string,
        telefone?: string,
        cep?: string,
        tipoEndereco?: string,
        logradouro?: string,
        numero?: string,
        complemento?: string,
        bairro?: string,
        cidade?: string,
        estado?: string,
    ) {
      this.nomeSubCliente = nomeSubCliente;
      this.cpfCnpj = cpfCnpj;
      this.email = email;
      this.telefone = telefone;
      this.cep = cep;
      this.tipoEndereco = tipoEndereco;
      this.logradouro = logradouro;
      this.numero = numero;
      this.complemento = complemento;
      this.bairro = bairro;
      this.cidade = cidade;
      this.estado = estado;
    }
  }